'use strict';

define('vb/private/translations/translationContext',['ojs/ojtranslation'], (ojTranslation) => {
  /**
   *
   */

  class TranslationContext {
    constructor() {
      throw new Error('TranslationContext is a set of static methods, do not call constructor');
    }

    /**
     * create an object with just properties we want to expose to the expression context
     * @param bundles
     * @returns {*}
     */
    static createContext(bundles) {
      // if no bundles yet, just return the utility method(s), and don't look up the key
      // just in case this is called before the bundles are loaded, which shouldn't happen
      if (!bundles) {
        return {
          format: (_, str, ...params) => ojTranslation.applyParameters(str, ...params),
        };
      }

      const utilities = {
        format: (bundleName, key, ...params) => {
          // if no bundleName is passed, assume they are referencing a bundle named 'format'
          if (arguments.length === 0) {
            return bundles.getStringMap().format;
          }

          // delegate formatting to the actual instance (BundleDefinition or BundleV2Definition).
          const bundleDef = bundles.bundleDefinitionsMap[bundleName];
          return bundleDef.format(key, ...params);
        },
      };

      return Object.assign({}, bundles.getStringMap(), utilities);
    }
  }

  // all static
  return TranslationContext;
});

